module.exports = __webpack_public_path__ + "media/en_gb_s1_Alice.73143b16.oga";